import { Text, tokens } from '@fluentui/react-components';
import { MainContext, RecordContext, useT } from '@powerportalspro/react';
import {
  MenuBar,
  RefreshContextButton,
  SaveContextButton,
  Section,
  SectionColumn,
  TextEdit,
} from '@powerportalspro/react-fluent';

// Mirror Blazor's `MainContextMainDemo` keys so both stacks share the
// JSON.
const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Contexts.MainContext.MainContextMainDemo';

// `<MainContext>` is invisible on its own — the sample renders two
// nested `<RecordContext>` siblings + a toolbar (Save / Refresh) so the
// context's coordination role is actually visible: one Save button
// commits edits across both records in a single transactional batch.
//
// Both records are wired against the demo's `ppp_contact` and
// `ppp_democustomtable` tables (same shape the Blazor demo uses), which
// keeps the sample faithful to the underlying pattern even though the
// outer providers in `define-sample-element.tsx` don't fetch them in
// isolation — the value here is the wrapper structure, not loading
// data.
export function MainContextMainSample() {
  const t = useT();
  return (
    <MainContext warnOnUnsavedChanges={false}>
      <MenuBar style={{ marginBottom: tokens.spacingVerticalM }}>
        <SaveContextButton appearance="primary" />
        <RefreshContextButton />
      </MenuBar>
      <Section>
        <SectionColumn header={<Text weight="semibold">{t(`${STRINGS_BASE}.contact-label`)}</Text>}>
          <RecordContext table="ppp_contact">
            <TextEdit columnName="ppp_firstname" />
            <TextEdit columnName="ppp_lastname" />
          </RecordContext>
        </SectionColumn>
        <SectionColumn header={<Text weight="semibold">{t(`${STRINGS_BASE}.account-label`)}</Text>}>
          <RecordContext table="ppp_democustomtable">
            <TextEdit columnName="ppp_name" />
          </RecordContext>
        </SectionColumn>
      </Section>
    </MainContext>
  );
}
